import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import { showModal, showFadeCarregando, showAlerta, preencherListagem } from '@common/common.action';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  exibirModal,
  liberarLaudoTotalmente,
} from './store/liberacaoTotal.action';
import IntlMessage from '../../../../helpers/intlMessage';

const ModalLiberar = (props) => {
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const history = useHistory();

  function toggle() {
    props.exibirModal();
    props.showModal(false);

    if (props.isGoBack)
      history.goBack();
  }

  function liberarLaudo() {
    const listagem = [...props.listagem];
    const listagemIndex = listagem.findIndex(
      item => item.laudo === props.laudo
    );
    if(listagemIndex>= 0){
      listagem[listagemIndex].dataLiberacao = new Date().toLocaleDateString();
      listagem[listagemIndex].isLaudoLiberado = true;
      listagem[listagemIndex].isLiberadoTotal = true;
      props.preencherListagem(listagem);
    }
    props.liberarLaudoTotalmente();
    props.exibirModal();
    props.showModal(false);
    props.showFadeCarregando(true)

    setTimeout(() => {
      props.showFadeCarregando(false);
      if (props.isGoBack)
        history.goBack();
      else {
        var lista = [];
        // eslint-disable-next-line array-callback-return
        props.listagem.map((item, i) => {
          if (item.laudo === props.laudo) {
            item.isLiberadoTotal = true;
            item.isLaudoLiberado = true;
          }
          lista.push(item);
        })
        props.preencherListagem(lista);
      }
    }, 200);
  }

  return (
    <Modal
      size={'ie'}
      isOpen={props.modalAberto}
      toggle={toggle}
      backdrop={backdrop}
      keyboard={keyboard}
      centered
    >
      <ModalHeader toggle={props.toggle}>
        <IntlMessage id = "dashboards.examDetail.fullRelease"/>
      </ModalHeader>

      <div style={{ marginLeft: '15px', marginTop: '20px' }}>
        <span><IntlMessage id = "dashboards.examDetail.fullyReleaseReport"/></span>
      </div>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          <IntlMessage id = "dashboards.examDetails.no"/>
        </Button>
        <Button color="primary" onClick={() => liberarLaudo()}>
          <IntlMessage id = "dashboards.examDetails.confirm"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

// export default Liberar;

const mapStateToProps = (state) => ({
  modalAberto: state.modalLiberacaoTotal.modalAberto,
  laudo: state.modalLiberacaoParcial.laudo,
  listagem: state.commonReducer.listagem,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { exibirModal, liberarLaudoTotalmente, showModal, showFadeCarregando, showAlerta, preencherListagem },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalLiberar);



// WEBPACK FOOTER //
// ./src/pages/laudo/modais/liberacao_total/index.js